import { Component, OnInit, Input, ViewContainerRef, ContentChild } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { NdmsFormControlComponent } from '../ndms-form-control/ndms-form-control.component';
import { HasSearchModalComponent } from '../../../core/interfaces/hasSearchModalComponent';

@Component({
  selector: 'ndms-textbox-search',
  templateUrl: './ndms-textbox-search.component.html',
  styleUrls: ['./ndms-textbox-search.component.scss']
})
export class NdmsTextboxSearchComponent extends NdmsFormControlComponent implements OnInit {

  @Input() field: string;
  @Input() group: FormGroup;
  @Input() size: string;
  @Input() placeholder: string;

  @Input() label: string;
  @Input() labelHidden: boolean;

  @Input() required: string;

  @Input() displayField: string;
  @Input() dataField: string;

  @ContentChild(HasSearchModalComponent) hasSearchModal: HasSearchModalComponent

  displayText: string;

  constructor(viewContainerRef: ViewContainerRef) {
    super(viewContainerRef);
  }

  get formControl() {
    return (<FormControl>this.group.get(this.field));
  }
  ngAfterContentInit() {
    this.hasSearchModal.searchControl = (<FormControl>this.group.controls[this.field]);
    this.hasSearchModal.onSelected = (selectedResult: any) => {
      this.displayText = selectedResult[this.displayField];

      if(this.dataField) {
        this.formControl.setValue(selectedResult[this.dataField]);
      }
      else {
        this.formControl.setValue(selectedResult);
      }
    }
  }

  clearSelection() { 
    this.formControl.setValue(null);
    this.displayText = "";
  }

}
